import apiClient from './apiClient';
import type { TickerPulseSummary, TickerPulseDetail } from '../types/marketPulse';

export interface MaxPainHistoryItem {
  date: string;
  max_pain: number;
  spot_price: number | null;
}

export interface TopPick {
  ticker: string;
  spot_price: number;
  score: number;
  thesis: string;
  factors: string[];
  target: number | null;
  stop: number | null;
  rr_ratio: number | null;
  strategy: { name: string; strikes: string | null } | null;
  entry_zone: { direction: string; zone_high: number; zone_low: number; zone_high_label: string; zone_low_label: string; guidance: string } | null;
  sentiment: string;
  gex_regime: string;
  iv_regime: string;
  computed_at: string | null;
}

export const marketPulseService = {
  getSummary: () =>
    apiClient.get<TickerPulseSummary[]>('/api/discover/market-pulse').then((r) => r.data),

  getDetail: (ticker: string) =>
    apiClient.get<TickerPulseDetail>(`/api/discover/market-pulse/${ticker}`).then((r) => r.data),

  getTopPicks: (limit: number = 5) =>
    apiClient.get<{ picks: TopPick[]; pulse_date: string | null }>('/api/discover/market-pulse/top-picks', { params: { limit } }).then((r) => r.data),

  refreshTicker: (ticker: string) =>
    apiClient.post<{ status: string; ticker: string; rows_collected: number }>(`/api/discover/market-pulse/${ticker}/refresh`).then((r) => r.data),

  getOptionStrikes: (ticker: string, expiry: string, optionType: string) =>
    apiClient.get<number[]>('/api/discover/option-strikes', { params: { ticker, expiry, option_type: optionType } }).then((r) => r.data),

  getOptionPrice: (ticker: string, strike: number, expiry: string, optionType: string) =>
    apiClient.get<{ mid: number | null; bid: number | null; ask: number | null }>(
      '/api/discover/option-price', { params: { ticker, strike, expiry, option_type: optionType } }
    ).then((r) => r.data),

  getMaxPainHistory: (ticker: string, days: number = 7) =>
    apiClient.get<{ ticker: string; items: MaxPainHistoryItem[] }>(`/api/discover/market-pulse/${ticker}/max-pain-history`, { params: { days } }).then((r) => r.data),
};
